<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            调拨单号：<span v-if="formData.whtowhNo"
                           style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.whtowhNo }}</span>
            <span v-else class="information"> 待生成</span>

            <!-- 状态 1制单;2审核;3出库;4入库;5驳回;99取消-->
            <span v-if="formData.stat==1" class="information">制单</span>
            <span v-else-if="formData.stat==2" class="information">审核</span>
            <span v-else-if="formData.stat==3" class="information">出库</span>
            <span v-else-if="formData.stat==4" class="information">入库</span>
            <span v-else-if="formData.stat==5" class="information">驳回</span>
            <span v-else-if="formData.stat==99" class="information">取消</span>

          </div>
          <div style="display:none">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <div class="fr" v-if="formData.stat==1">
            <el-button type="primary"
                       v-if="transferCheck && formData.id
                       && (currentIsSite ? currentSiteData.id == formData.outSiteId : true)"
                       class="button-sty"
                       icon="el-icon-s-claim"
                       @click="showAuditPop=true;operationType='审核'">审核
            </el-button>
            <!--            <el-button type="primary" v-if="transferRejected && formData.id" class="button-sty" icon="el-icon-refresh-right"-->
            <!--                       @click="showCancelOrRejectPop=true;operationType='驳回'">驳回-->
            <!--            </el-button>-->
            <el-button type="primary"
                       v-if="transferCancel && formData.id
                       && (currentIsSite ? currentSiteData.id == formData.inSiteId : true)"
                       class="button-sty"
                       icon="el-icon-delete"
                       @click="showCancelOrRejectPop=true; operationType='取消'">取消
            </el-button>
            <el-button type="primary"
                       class="button-sty"
                       icon="el-icon-check"
                       v-if="transferAdd
                       && ((transferAdd && formData.id === null) || (transferEdit && formData.id !== null))"
                       @click="saveData">保存
            </el-button>
          </div>
          <div class="fr" v-if="formData.stat==2">
            <el-button type="primary"
                       v-if="transferOut && (currentIsSite ? currentSiteData.id == formData.outSiteId : true)"
                       class="button-sty"
                       icon="el-icon-s-claim"
                       @click="showAuditPop=true; operationType='出库'">出库
            </el-button>
          </div>
          <div class="fr" v-if="formData.stat==3">
            <el-button type="primary"
                       v-if="transferIn && (currentIsSite ? currentSiteData.id == formData.inSiteId : true)"
                       class="button-sty"
                       icon="el-icon-s-claim"
                       @click="showAuditPop=true; operationType='入库'">入库
            </el-button>
          </div>
        </div>


        <!-- 基本信息 -->
        <dix style="overflow-y: scroll!important;
    height: 100vh!important; ">
          <div class="d-cont edit-mce-box">
            <div class="d-item">
              <div class="title first"><b>业务信息</b></div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    调拨类型
                  </th>
                  <td v-if="!justShow">
                    <el-form-item>
                      <el-select v-model="formData.whtowhType" @change="whtowhTypeChange" style="width: 100%" clearable>
                        <el-option v-if="!currentIsSite" label="总部间调拨" :value="1"/>
                        <el-option v-if="!currentIsSite" label="总部网点调拨" :value="2"/>
                        <el-option label="网点间调拨" :value="3"/>
                        <el-option v-if="!currentIsSite" label="机构间调拨" :value="4"/>
                        <el-option v-if="!currentIsSite" label="总部机构间调拨" :value="5"/>
                        <el-option v-if="!currentIsSite" label="机构网点间调拨" :value="6"/>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td v-else>
                    {{
                      formData.whtowhType == 1 ? '总部间调拨' :
                        formData.whtowhType == 2 ? '总部网点调拨' :
                          formData.whtowhType == 3 ? '网点间调拨' :
                            formData.whtowhType == 4 ? '机构间调拨' :
                              formData.whtowhType == 5 ? '总部机构间调拨' :
                                formData.whtowhType == 6 ? '机构网点间调拨' : ""
                    }}
                  </td>

                  <th>调拨单号</th>
                  <td>{{ formData.whtowhNo }}</td>

                  <th>调拨状态</th>
                  <td><span v-if="formData.stat==1">制单</span>
                    <span v-else-if="formData.stat==2">审核</span>
                    <span v-else-if="formData.stat==3">出库</span>
                    <span v-else-if="formData.stat==4">入库</span>
                    <span v-else-if="formData.stat==5">驳回</span>
                    <span v-else-if="formData.stat==99">取消</span></td>
                  <th>调拨性质</th>
                  <td v-if="!justShow">
                    <el-form-item>
                      <el-select v-model="formData.properties" @change="propertiesChange" style="width: 100%" clearable>
                        <el-option  label="常规" :value="0"/>
                        <el-option  label="工单" :value="1"/>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td v-else>
                    {{
                      formData.properties == 0 ? '常规' :
                        formData.properties == 1 ? '工单' :""
                    }}
                  </td>
                </tr>
                <tr>

                  <th>
                    <em class="f-red">*</em>
                    调出机构名称
                  </th>
                  <td v-if="!justShow">
                    <org-search :org-id.sync="formData.outOrgId"
                                :org-name.sync="formData.outOrgName"
                                :org-id-path.sync="formData.outOrgIdPath"
                                @clear="() => {formData.outSiteName = null; formData.outSiteId = null}"
                    />

                  </td>
                  <td v-else>{{ formData.outOrgName }}</td>

                  <th>
                    <!-- <em class="f-red">*</em> -->
                    调出网点名称
                  </th>
                  <td v-if="!justShow">
                    <all-site-pop-search :site-id.sync="formData.outSiteId"
                                         :site-name.sync="formData.outSiteName"
                                         :org-id.sync="formData.outOrgId"
                                         :org-id-path.sync="formData.outOrgIdPath"
                                         :org-name.sync="formData.outOrgName"
                                         :editable="formData.whtowhType==3"
                                         @valueChange="outSiteCommit"
                    />

                  </td>
                  <td v-else>{{ formData.outSiteName }}</td>

                  <th>
                    <em class="f-red">*</em>
                    调出仓库名称
                  </th>
                  <td v-if="!justShow">
                    <el-select v-model="formData.outWarehouseId"  clearable
                               @change="formData.spWhtowhLineDTOList = []"
                               @click.native="warehouseClick('out')">
                      <el-option v-for="item in outWarehouseList" :key="item.id" :label="item.warehouseName"
                                 :value="item.id"/>
                    </el-select>
                  </td>
                  <td v-else>{{ formData.outWarehouseName }}</td>
                  <th>
                    工单号
                  </th>
                  <td v-if="!justShow">
                    <el-input type="text" autocomplete="off" v-model="formData.orderNo"
                           :readonly="true"   :disabled="this.canSelectOrderNo"  >
                      <i slot="suffix" class="el-input__icon el-icon-search"
                         v-if="!this.canSelectOrderNo"  @click="showOrderDialog = true" ></i>
                    </el-input>
                  </td>
                  <td v-else>
                    {{formData.orderNo}}
                  </td>
                </tr>
                <tr>
                  <th>
                    <!--                      <em class="f-red">*</em>-->
                    发出地址
                  </th>
                  <td colspan="3" v-if="!justShow">
                    <el-input type="text" autocomplete="off" v-model="formData.outAddress" clearable/>
                  </td>
                  <td colspan="3" v-else>{{ formData.outAddress }}</td>
                </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    调入机构名称
                  </th>
                  <td v-if="!justShow">
                    <org-search :org-id.sync="formData.inOrgId"
                                :org-name.sync="formData.inOrgName"
                                :org-id-path.sync="formData.inOrgIdPath"
                                :show="true"
                                @clear="() => {formData.inSiteName = null; formData.inSiteId = null}"
                    />
                  </td>
                  <td v-else>{{ formData.inOrgName }}</td>

                  <th>
                    <!-- <em class="f-red">*</em> -->
                    调入网点名称
                  </th>
                  <td v-if="!justShow">
                    <!--                    <site-pop-search :site-id.sync="formData.inSiteId"-->
                    <!--                                     :site-name.sync="formData.inSiteName"-->
                    <!--                                     :org-id.sync="formData.inOrgId"-->
                    <!--                                     :org-id-path.sync="formData.inOrgIdPath"-->
                    <!--                                     :org-name.sync="formData.inOrgName"-->
                    <!--                                     :editable="(formData.whtowhType==2||formData.whtowhType==3||formData.whtowhType==6) && !currentIsSite""-->
                    <!--                                     @valueChange="inSiteCommit"-->
                    <!--                    />-->

                    <all-site-pop-search :site-id.sync="formData.inSiteId"
                                         :site-name.sync="formData.inSiteName"
                                         :org-id.sync="formData.inOrgId"
                                         :org-id-path.sync="formData.inOrgIdPath"
                                         :org-name.sync="formData.inOrgName"
                                         :editable="(formData.whtowhType==2||formData.whtowhType==3||formData.whtowhType==6)"
                                         @valueChange="inSiteCommit"
                    />
                  </td>
                  <td v-else>{{ formData.inSiteName }}</td>

                  <th>
                    <em class="f-red">*</em>
                    调入仓库名称
                  </th>
                  <td v-if="!justShow">
                    <el-select v-model="formData.inWarehouseId"  clearable
                               @click.native="warehouseClick('in')">
                      <el-option v-for="item in inWarehouseList" :key="item.id" :label="item.warehouseName"
                                 :value="item.id"/>
                    </el-select>
                  </td>
                  <td v-else>{{ formData.inWarehouseName }}</td>


                </tr>
                <tr>
                  <th>
                    <!--                      <em class="f-red">*</em>-->
                    收货地址
                  </th>
                  <td colspan="3" v-if="!justShow">
                    <el-input type="text" autocomplete="off" v-model="formData.inAddress" clearable/>
                  </td>
                  <td colspan="3" v-else>{{ formData.inAddress }}</td>
                </tr>
                <tr v-if="formData.remark">
                  <th>备注</th>
                  <td>{{ formData.remark }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
                <div class="title first"><b>调拨明细</b></div>
                <div class="item-button" style="margin-top: 8px;" v-if="!justShow">
                  <el-button type="primary" class="button-sty btn_zdy" @click="showImportPop">
                    <i class="el-icon-plus"></i>
                    导入明细
                  </el-button>&nbsp;
                  <el-button type="primary" class="button-sty btn_zdy" @click="showDetailsPop">
                    <i class="el-icon-plus"></i>
                    添加明细
                  </el-button>&nbsp;
                  <el-button
                    type="primary" class="button-sty btn_zdy" @click="deleteData">
                    <i class="el-icon-delete"></i>
                    批量删除
                  </el-button>
                </div>
              </div>
              <div>
                <!-- <div class="title first"><b>历史工单</b></div> -->
                <vxe-table
                  style="margin-top: 5px;"
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  @checkbox-change="selectChangeEvent"
                  @checkbox-all="selectChangeEvent"
                  show-overflow
                  height="120" :column-config="{ resizable: true }"
                  :data="formData.spWhtowhLineDTOList"
                >
                  <vxe-column type="checkbox" width="40"/>
                  <vxe-column field="partsCode" title="配件编码" width="180"></vxe-column>
                  <vxe-column field="partsName" title="配件名称" width="120"></vxe-column>
                  <vxe-column field="invQty" title="库存数量" width="90"></vxe-column>
                  <vxe-column field="takeUpQty" title="占用数量" width="90"></vxe-column>
                  <vxe-column field="qty" title="调拨数量" width="110">
                    <template #default="{row}">
                      <!--                      <vxe-input size="small" v-if="!justShow" v-model="row.qty" type="number" min="1" :max="Number(row.partsInvQty) - Number(row.partsTakeUpQty)"-->
                      <!--                                 :clearable="false"></vxe-input>-->
                      <!--                      <span v-else>{{ row.qty }}</span>-->
                      <vxe-input size="small" v-if="!justShow" v-model="row.qty" type="number" :min="1"
                                 :max="row.invQty"
                                 :clearable="false" :input="inputFunc(row)"></vxe-input>
                      <span v-else>{{ row.qty }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="price" title="单价" width="90">
                    <template #default="{row}">
                      <span v-if="isSite">*</span>
                      <span v-else>{{ row.price }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="amount" title="调拨金额" width="90">
                    <template #default="{row}">
                      <span v-if="isSite">*</span>
                      <span v-else>{{ row.qty * row.price }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="checkQty" title="审核数量" width="90"></vxe-column>
                  <!-- <vxe-column field="checkAmount" title="审核金额" width="90"></vxe-column> -->
                  <vxe-column field="outQty" title="出库数量" width="90"></vxe-column>
                  <!-- <vxe-column field="outAmount" title="出库金额" width="90"></vxe-column> -->
                  <vxe-column field="inQty" title="入库数量" width="90"></vxe-column>
                  <!-- <vxe-column field="inAmount" title="入库金额" width="90"></vxe-column> -->
                </vxe-table>
              </div>
            </div>
            <!-- 数量&金额 -->
            <div class="d-item">
              <div class="title first"><b>数量&金额</b></div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>调拨总数量</th>
                  <td>{{ formData.qty }}</td>

                  <th>调拨总金额</th>
                  <td v-if="isSite">*</td>
                  <td v-else>{{ formData.amount }}</td>

                  <th>审核总数量</th>
                  <td>{{ formData.checkQty }}</td>

                  <th>审核总金额</th>
                  <td v-if="isSite">*</td>
                  <td v-else>{{ formData.checkAmount }}</td>

                </tr>
                <tr>
                  <th>出库总数量</th>
                  <td>{{ formData.outQty }}</td>

                  <th>出库总金额</th>
                  <td v-if="isSite">*</td>
                  <td v-else>{{ formData.outAmount }}</td>

                  <th>入库总数量</th>
                  <td>{{ formData.inQty }}</td>

                  <th>入库总金额</th>
                  <td v-if="isSite">*</td>
                  <td v-else>{{ formData.inAmount }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div class="title first"><b>配送信息</b></div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>配送方式</th>
                  <td>{{ formData.deliverTypeName }}</td>

                  <th>物流公司</th>
                  <td>{{ formData.deliverCompanyName }}</td>

                  <th>物流电话</th>
                  <td>{{ formData.deliverMobile }}</td>

                  <th>物流单号</th>
                  <td>
                      <span v-if="formData.deliverNo != null && formData.deliverNo !== 0"
                            style="color: blue; cursor:pointer;" @click="showDeliverNoForOther()">
                                 {{ formData.deliverNo }}
                      </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div class="title first"><b>节点信息</b></div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>申请时间</th>
                  <td>{{ formData.applyDate }}</td>

                  <th>审核时间</th>
                  <td>{{ formData.checkDate }}</td>

                  <th>出库时间</th>
                  <td>{{ formData.outDate }}</td>

                  <th>入库时间</th>
                  <td>{{ formData.inDate }}</td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>
        </dix>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

    <warehousePop v-if="showWarehousePop"
                  @commit="warehouseCommit"
                  :visiable.sync="showWarehousePop"
                  multi="true"/>

    <partsInvDialog v-if="showPreconditionDialog"
                    :warehouse-id="formData.outWarehouseId"
                    @confirm="commitSelectedRow"
                    :visiable.sync="showPreconditionDialog"
                    multi="true"/>

    <cancelOrReject v-if="showCancelOrRejectPop"
                    :visiable.sync="showCancelOrRejectPop"
                    @closeD="closeD"
                    @goBackIndex="goBackIndex"
                    :data-id="formData.id"
                    :type="operationType"
    />

    <!-- <auditPop v-if="showAuditPop"
              :visiable.sync="showAuditPop"
              @closeD="closeD"
              @goBackIndex="goBackIndex"
              :id="formData.id"
              :type="operationType"
    /> -->
    <!-- 新 -->
    <transferDialog v-if="showAuditPop"
                    :visiable.sync="showAuditPop"
                    @closeD="closeD"
                    @goBackIndex="getTableData"
                    :id="checkedRowId"
                    :type="operationType"
    />
    <WorkOrderDialog v-if="showOrderDialog" @commit="commitSelectedRowForOrder"
                     :visiable.sync="showOrderDialog" multi="true"
    />

    <setDeliverNoDialog v-if="showSetDeliverNoDialog" :data-id="formData.id" :visiable.sync="showSetDeliverNoDialog"
                        multi="true" @goBackIndex="goBackIndex"/>

    <logistics-information-info-dialog v-if="showLogisticsInformationInfoDialog"
                                       :visiable.sync="showLogisticsInformationInfoDialog"
                                       :formData="logisticsInformationInfo"
    />

    <excel-upload
      ref="excelUpload"
      title="明细批量导入"
      :url="api.spWhtowhHead.importLineUrl"
      temp-url="https://bladex-vatti.oss-cn-shenzhen.aliyuncs.com/css-prod-unify-deploy-package/uploadTemp/%E8%B0%83%E6%8B%A8%E6%98%8E%E7%BB%86%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5.xlsx"
      :outWarehouseId = "this.formData.outWarehouseId"
      @refreshDataList="importLineData"
    ></excel-upload>

  </div>
</template>

<script>
import api from "@/api/projectApi";


import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
// import {dictType, loadDictData} from "@/config/dictType";
import partsInvDialog from '@/views/dialogCommon/partsInvDialog.vue'
import cancelOrReject from './cancelOrReject.vue'
import auditPop from './audit.vue'
import orgSearch from "@/components/formItem/orgSearch.vue"
import sitePopSearch from "@/components/formItem/sitePopSearch.vue"
import allSitePopSearch from "@/components/formItem/allSitePopSearch.vue"
import {editPageMixins, siteMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";
// 新
import transferDialog from "./transferDialog.vue";
import WorkOrderDialog from "./workOrderDialog.vue";
import store from "@/store";
import SetDeliverNoDialog from "@/views/accessories/applyFor/apply/setDeliverNoDialog.vue";
import LogisticsInformationInfoDialog from "@/views/accessories/applyFor/apply/logisticsInformationInfoDialog.vue";
import ExcelUpload from "./excel.vue";


export default {
  mixins: [editPageMixins, siteMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    LogisticsInformationInfoDialog,
    SetDeliverNoDialog,
    orgSearch,
    sitePopSearch,
    warehousePop,
    partsInvDialog,
    cancelOrReject,
    auditPop,
    allSitePopSearch,
    transferDialog,
    WorkOrderDialog,
    ExcelUpload
  },
  data() {
    return {
      checkedRowId: null,
      isSite: null,

      transferAdd: false,
      transferEdit: false,
      transferCancel: false,
      transferCheck: false,
      transferRejected: false,
      transferOut: false,
      transferIn: false,

      orgType: null,
      showOrgDialog: false,
      inWarehouseType: null,
      outWarehouseType: null,
      showOutSitePop: false,
      showInSitePop: false,
      showCancelOrRejectPop: false,
      showAuditPop: false,
      showLogisticsInformationInfoDialog:false,
      logisticsInformationInfo:null,
      justShow: false,

      operationType: null,

      outWarehouseList: [],
      inWarehouseList: [],
      selectedData: [],

      showSitePop: false,
      showOrderPop: false,
      showWarehousePop: false,
      showPreconditionDialog: false,

      shippingMethodList: [],
      logisticsCompaniesList: [],
      canSelectOrderNo: true,
      showOrderDialog:false,
      showSetDeliverNoDialog:false,
      formData: {
        orderNo:null,
        properties:0,
        remark: null,
        whtowhNo: null,  // 调拨单号;前缀"WH"+年月日+6位流水号
        whtowhType: null,  // 调拨类型：1总部间调拨;2总部网点调拨;3网点间调拨;4机构间调拨;5总部机构间调拨;6机构网点间调拨
        stat: 1,  // 状态:1制单;2审核;3出库;4入库;5驳回;99取消
        outOrgId: null,  // 调出机构id，关联bas_org.id
        outOrgName: null,  // 调出机构名称,冗余字段
        outOrgIdPath: null,  // 调出机构ID路径,冗余字段.重要
        outSiteId: '',  // 调出网点id，关联bas_user.id
        outWarehouseId: null,  // 调出库仓id:关联bas_warehouse.id字段
        outAddress: null,  // 发出地址
        inOrgId: '',  // 调入机构id，关联bas_org.id
        inOrgName: '',  // 调入机构名称,冗余字段
        inOrgIdPath: '',  // 调入机构ID路径,冗余字段.重要
        inSiteId: '',  // 调入网点id，关联bas_user.id
        inWarehouseId: null,  // 调入库仓id:关联bas_warehouse.id字段
        inAddress: null,  // 收货地址
        deliverType: 0,  // 配送方式ID，关联脚手架数据字典项目表sys_dict_item.id
        deliverTypeName: null,  // 配送方式名称,冗余字段
        deliverCompany: 0,  // 物流公司ID，关联脚手架数据字典项目表sys_dict_item.id
        deliverCompanyName: null,  // 物流公司名称,冗余字段
        deliverNo: null,  // 物流单号
        qty: 0,  // 调拨总数量
        amount: 0,  // 调拨总金额
        checkQty: 0,  // 审核总数量
        checkAmount: 0,  // 审核总金额
        outQty: 0,  // 出库总数量
        outAmount: 0,  // 出库总金额
        inQty: 0,  // 入库总数量
        inAmount: 0,  // 入库总金额
        applyDate: null,  // 申请时间
        checkDate: null,  // 审核时间
        outDate: null,  // 出库时间
        inDate: null,  // 入库时间
        spWhtowhLineDTOList: [],

        inSiteName: null,
        outSiteName: null,
        inWarehouseName: null,
        outWarehouseName: null,
      },

      show3: false,
      node: true,


      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
  },
  created() {
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      console.log("userInfo58585858585555555555555"+userInfo.snUserId)
      this.isSite = true;
    }
    if (this._dataId && !isNaN(this._dataId)) this.checkedRowId = this.dataId = this._dataId;

    this.transferAdd = this.permissions['transferAdd']
    this.transferEdit = this.permissions['transferEdit']
    this.transferCancel = this.permissions['transferCancel']
    this.transferCheck = this.permissions['transferCheck']
    this.transferOut = this.permissions['transferOut']
    this.transferIn = this.permissions['transferIn']
    this.transferRejected = this.permissions['transferRejected']
  },
  mounted() {
    this.getData()
    // this.loadDictData()
  },
  watch: {
    'formData.spWhtowhLineDTOList': {
      handler(n) {
        if (n) {
          let allQty = 0
          let allAmount = 0
          n.forEach(item => {
            allQty += Number(item.qty)
            allAmount += Number(item.price) * Number(item.qty)
          })
          this.formData.qty = allQty
          this.formData.amount = allAmount.toFixed(2)
        }
      },
      deep: true
    },

  },
  methods: {
    beforeUpload(file) {
      if (!this.formData.outWarehouseId) {
        this.$message.error('请先选择调出仓库！');
        return false;
      }

      this.$refs.excelUpload.uploadData = {
        ...this.$refs.excelUpload.uploadData,
        outWarehouseId: this.formData.outWarehouseId
      };

      return true;
    },
    importLineData(data) {
      console.log('导入明细', data)
      let list = this.formData.spWhtowhLineDTOList

      let f = 1
      data.forEach(item => {
        list.push({
          id: -new Date().getTime() + Math.floor(Math.random() * 1000),
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          qty: item.applyQty,
          price: item.sitePrice,
          amount: item.applyAmount,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          inQty: 0,
          inAmount: 0,
          takeUpQty: item.usedQty,
          invQty: item.invQty,
          isNew: true
        })
      })

      this.formData.spWhtowhLineDTOList = list
    },
    setSiteData() {
      let site = this.currentSiteData;
      this.formData.inSiteId = site.id
      this.formData.inSiteName = site.userName
      this.formData.inOrgId = site.snSiteInfoDTO.orgId
      this.formData.inOrgIdPath = site.snSiteInfoDTO.orgIdPath
      this.formData.inOrgName = site.snSiteInfoDTO.orgName

      let temp = ''
      if (site.userProvince) {
        temp += site.userProvince
      }
      if (site.userCity) {
        temp += site.userCity
      }
      if (site.userCounty) {
        temp += site.userCounty
      }
      if (site.userTown) {
        temp += site.userTown
      }
      if (site.userAddress) {
        temp += site.userAddress
      }

      this.formData.inAddress = temp
      this.formData.whtowhType = 3
    },

    inputFunc(row) {
      let invQty = Number(row.invQty)
      if (Number(row.qty) > invQty) {
        row.qty = invQty
        this.$message.warning('调拨数量不能超过库存')
      }
    },

    warehouseTypeSet() {
      // 调拨类型：1总部间调拨;2总部网点调拨;3网点间调拨;4机构间调拨;5总部机构间调拨;6机构网点间调拨
      let whtowhType = this.formData.whtowhType
      if (whtowhType == 1) {
        this.outWarehouseType = 0
        this.inWarehouseType = 0
      } else if (whtowhType == 2) {
        this.outWarehouseType = 0
        this.inWarehouseType = 3
      } else if (whtowhType == 3) {
        this.outWarehouseType = 3
        this.inWarehouseType = 3
      } else if (whtowhType == 4) {
        this.outWarehouseType = 1
        this.inWarehouseType = 1
      } else if (whtowhType == 5) {
        this.outWarehouseType = 0
        this.inWarehouseType = 1
      } else if (whtowhType == 6) {
        this.outWarehouseType = 1
        this.inWarehouseType = 3
      }
    },

    warehouseClick(type) {
      // 调拨类型：1总部间调拨;2总部网点调拨;3网点间调拨;4机构间调拨;5总部机构间调拨;6机构网点间调拨
      let whtowhType = this.formData.whtowhType
      if (!whtowhType) {
        this.$message.warning('请先选中调拨类型')
        return
      }

      this.warehouseTypeSet()

      if (type === 'out') {
        if (this.outWarehouseType === 3 && !this.formData.outSiteId) {
          this.$message.warning('请先选中拨出网点')
          return
        }
        this.loadOutWarehouse()
      } else if (type === 'in') {
        if (this.inWarehouseType === 3 && !this.formData.inSiteId) {
          this.$message.warning('请先选中拨入网点')
          return
        }
        this.loadInWarehouse()
      }

    },

    loadOutWarehouse() {
      this.$http.post(api.spWhtowhHead.getWarehouseDataUrl, {
        warehouseType: this.outWarehouseType,
        siteId: this.formData.outSiteId,
        // excludeWarehouseId: this.formData.inWarehouseId
      }).then(res => {
        this.outWarehouseList = res.data.data
      })
    },

    loadInWarehouse() {
      this.$http.post(api.spWhtowhHead.getWarehouseDataUrl, {
        warehouseType: this.inWarehouseType,
        siteId: this.formData.inSiteId,
        // excludeWarehouseId: this.formData.outWarehouseId
      }).then(res => {
        this.inWarehouseList = res.data.data
      })
    },
    propertiesChange(){
      if(this.formData.properties === 1){
        this.canSelectOrderNo = false
      }else{
        this.canSelectOrderNo = true
        this.formData.orderNo = ''

      }
    },
    // 调拨状态改变
    whtowhTypeChange() {
      this.formData.outOrgId = null
      this.formData.outOrgIdPath = null
      this.formData.outOrgName = null
      this.formData.inOrgId = ''
      this.formData.inOrgIdPath = null
      this.formData.inOrgName = ''
      this.formData.inSiteId = null
      this.formData.inSiteName = null
      this.formData.outSiteId = null
      this.formData.outSiteName = null
      this.formData.outWarehouseId = null
      this.formData.inWarehouseId = null

      this.inWarehouseList = []
      this.outWarehouseList = []

      this.formData.spWhtowhLineDTOList = []
    },

    showDetailsPop() {
      if (this.formData.outWarehouseId) {
        this.showPreconditionDialog = true
      } else {
        this.$message.warning('请先选中调出仓库')
      }
    },

    showImportPop() {
      if (this.formData.outWarehouseId) {
        this.$refs.excelUpload.show()
      } else {
        this.$message.warning('请先选中调出仓库')
      }
    },


    // 明细删除
    deleteData() {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let temp = this.formData.spWhtowhLineDTOList
        this.selectedData.forEach(item => {
          temp = temp.filter(item1 => item1.id != item.id)
        })
        this.formData.spWhtowhLineDTOList = temp
      })
    },

    // 明细勾选
    selectChangeEvent(data) {
      this.selectedData = data.records
    },

    closeD() {
      this.showCancelOrRejectPop = false
      this.showAuditPop = false
      this.getData();
    },


    // 仓库弹框选中
    warehouseCommit(data) {
      console.log('选中的仓库', data)
      this.formData.outWarehouseId = data.warehouseId
      this.formData.outWarehouseName = data.warehouseName
    },

    // 调出网点弹框选中
    outSiteCommit() {
      let id = this.formData.outSiteId
      if (id && id != 0) {
        console.log('调出网点id', id)
        this.$http.post(api.snUser.getDataUrl, {id: id}).then(res => {
          let site = res.data.data;
          console.log('调出网点详情', site)

          let temp = ''
          if (site.userProvince) {
            temp += site.userProvince
          }
          if (site.userCity) {
            temp += site.userCity
          }
          if (site.userCounty) {
            temp += site.userCounty
          }
          if (site.userTown) {
            temp += site.userTown
          }
          if (site.userAddress) {
            temp += site.userAddress
          }

          this.formData.outAddress = temp
        })
      } else {
        this.formData.outAddress = null
      }
      this.formData.outWarehouseId = null
      this.formData.outWarehouseName = null
      this.formData.spWhtowhLineDTOList = []
    },

    // 调入网点弹框选中
    inSiteCommit() {
      let id = this.formData.inSiteId
      if (id && id != 0) {
        console.log('调入网点id', id)
        this.$http.post(api.snUser.getDataUrl, {id: id}).then(res => {
          let site = res.data.data;
          console.log('调入网点详情', site)

          let temp = ''
          if (site.userProvince) {
            temp += site.userProvince
          }
          if (site.userCity) {
            temp += site.userCity
          }
          if (site.userCounty) {
            temp += site.userCounty
          }
          if (site.userTown) {
            temp += site.userTown
          }
          if (site.userAddress) {
            temp += site.userAddress
          }

          this.formData.inAddress = temp
        })
      } else {
        this.formData.inAddress = null
      }
      this.formData.inWarehouseId = null
      this.formData.inWarehouseName = null
    },
    commitSelectedRowForOrder(data) {
      this.formData.orderNo=data.orderNo;
    },
    commitSelectedRow(data) {
      console.log('明细数据', data)
      let list = this.formData.spWhtowhLineDTOList

      data.forEach(item => {
        list.push({
          id: -new Date().getTime() + Math.floor(Math.random() * 1000),
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          qty: 1,
          price: item.price,
          amount: item.qty,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          inQty: 0,
          inAmount: 0,
          takeUpQty: item.takeUpQty,
          invQty: item.qty,
          isNew: true
        })
      })

      this.formData.spWhtowhLineDTOList = list
    },


    saveData() {
      if (this.currentIsSite && this.currentSiteData.id != this.formData.outSiteId && this.currentSiteData.id != this.formData.inSiteId) {
        this.$message.error("只允许对当前服务商进行调入或调出操作")
        return
      }

      const rules = {
        whtowhType: [{prop: '调拨类型', required: true}],
        outOrgId: [{prop: '调出机构', required: true}],
        inOrgId: [{prop: '调入机构', required: true}],
        outWarehouseId: [{prop: '调出仓库', required: true}],
        inWarehouseId: [{prop: '调入仓库', required: true}],
        spWhtowhLineDTOList: [{
          prop: '配件明细', type: 'list', required: true, rules: {
            qty: [{prop: '调拨数量', required: true, type: 'number'}]
          }
        }]
      }

      this.$validate(this.formData, rules).then(() => {
        if (this.formData.whtowhType == 3) {
          let inWarehouseId = this.formData.inWarehouseId;
          let inWarehouseName = null
          this.inWarehouseList.forEach(item => {
            if (item.id == inWarehouseId) {
              inWarehouseName = item.warehouseName
            }
          })

          let outWarehouseId = this.formData.outWarehouseId;
          let outWarehouseName = null
          this.outWarehouseList.forEach(item => {
            if (item.id == outWarehouseId) {
              outWarehouseName = item.warehouseName
            }
          })

          if (outWarehouseName != inWarehouseName) {
            this.$message.error('不能相互在好件仓和旧件仓之间调拨')
            return
          }
        }

        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          this.$http({
            url: api.spWhtowhHead.saveOrUpdateUrl,
            method: 'post',
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$message.success("保存成功！");
            this.goBackIndex()
            this.$mask.close()

          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });
        })
      })
    },
    showDeliverNoForOther() {
      this.$mask.open()
      this.$http.post(api.spWhtowhHead.getLogisticsInformationUrl,
        {id: this.formData.id,spWhtowhLineDTOList:[]}
      ).then(res => {
        this.logisticsInformationInfo = res.data.data
        this.showLogisticsInformationInfoDialog = true
        this.$mask.close()
      }).catch(() => {
        this.$mask.close()
      })
    },
    getData() {
      console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.spWhtowhHead.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          this.justShow = this.formData.stat != 1
          if(this.formData.properties === 1){
            this.canSelectOrderNo = false
          }
          this.warehouseTypeSet()
          this.loadOutWarehouse()
          this.loadInWarehouse()
        })
      }
    },

    goBackIndex() {
      this.$emit('goBackIndex')
    }

  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}


// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}


// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 8vw !important;
}

#containt .table-detail tbody tr td {
  width: 13vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
</style>
